import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('TotalAssetsValue').create(({ theme }) => ({
  root: {
    height: '100px',
    width: '100%',
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '12px',
    gap: '4px',
    borderRadius: '8px',
    boxShadow:
      '0px 0px 5px 0px rgba(243, 65, 20, 1), 0px 0px 10px 0px rgba(243, 202, 20, 0.5), 0px 0px 30px 0px rgba(0, 0, 0, 1) inset',
    border: '1px solid rgba(243, 202, 20, 1)',
    background: 'linear-gradient(90deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.03) 50%, rgba(0, 0, 0, 0.3) 100%)',
  },

  heading: {
    fontWeight: 450,
    fontSize: '18px',
    color: '#ff8000',
    position: 'relative',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  amountContainer: {
    background: 'rgba(17, 17, 17, 1)',
    padding: '5px 6px',
    borderRadius: '8px',
    boxShadow: '0px 1px 0px 0px rgba(0, 0, 0, 1) inset 0px 1px 0px 0px rgba(72, 72, 72, 1)',
    width: 'fit-content',
    height: 'auto',
    position: 'relative',
    span: {
      fontWeight: 440,
      fontSize: '32px',
      color: theme.colors.text.primary,
    },
  },
}))
